/**
 * Frontend permission check for nav/route/action gating.
 *
 * COSMETIC ONLY — the backend (middleware/auth.py require_permission deps)
 * is the real authorization boundary. `user.permissions` (string[]) arrives
 * on the login response user and on /auth/me, resolved server-side against
 * the catalogs in backend/utils/permissions.py. `admin` and `seller_admin`
 * are code-level superusers and always pass.
 */
export function can(user, perm) {
  return (
    user?.role === "admin" ||
    user?.role === "seller_admin" ||
    Boolean(user?.permissions?.includes(perm))
  );
}
